import { Component } from '@angular/core';
import { NavController, Events } from 'ionic-angular';
import { UserData } from '../../../../providers/user-data';
import { PageBase } from '../../../../core/page-base';
import { AppSettings } from '../../../../config/app-settings';
import { WeeklyAdCommon } from './weekly-ad.common';
import { Injector } from '@angular/core';
@Component({
	selector: 'page-weekly-ad',
  	templateUrl: 'weekly-ad.html'
})

export class WeeklyAdPage extends PageBase {
	public weeklyad:  string;
	public mySlideOptions = {
		initialSlide: 0,
		loop: true,
		pager: false
	};

	constructor(
		public injector: Injector,
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public events: Events,
		public common: WeeklyAdCommon
	) {

		super(settings, events, nav, userData);
	}

	ngAfterViewInit() {
		this.common.commonMethod();
		this.weeklyad =  "pageView";
	}

	ionViewDidEnter() {
		
	}
}



// WEBPACK FOOTER //
// ./src/modules/weekly-ad/pages/weekly-ad/weekly-ad.ts